import React from 'react';
import { useProcessDefinitionKey } from 'domain/gpo/cockpit/definition/processDefinitionRoute';
import { Navigate } from 'react-router-dom';
import { useProcessInstanceUrl } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import { ProcessState } from 'domain/gpo/cockpit/instance/processInstanceService';

const ProcessDefinitionRedirect = () => {
  const { getListUrl } = useProcessInstanceUrl();
  const key = useProcessDefinitionKey();

  const listUrl = getListUrl();
  const filterParam = `filter={"processKey":{"in":["${key}"]}, "state": {"eq":"${ProcessState.ACTIVE}"}}`;
  const url = `${listUrl}?${filterParam}`;

  return <Navigate to={url} replace />;
};

export default ProcessDefinitionRedirect;
